import {TranslateUtils} from '@wallaby-ui/core';
import React from 'react';
import {IntlShape} from 'react-intl';

type Props = {
  text: string | undefined;
  optional?: boolean;
  intl: IntlShape;
};
export const LightInputLabel: React.FC<Props> = (props) => {
  const {text, optional, intl} = props;
  return (
    <span>
      {TranslateUtils.translate(text ?? '', intl)}
      <span style={{color: 'var(--dlThemeGray-500)'}}>{optional && ` ${TranslateUtils.translate('global.optional', intl)}`}</span>
    </span>
  );
};
